import React from 'react'
import './styles'

# components
import Spinner    from '/components/spinner'
import Datetime   from '/components/datetime'
import StateLabel from '/components/state-label'
import Pager      from '/components/pager/history-pager'
import Filters    from '/components/filters'
import List       from '/components/list'

import FaCloudDownload from 'react-icons/lib/fa/cloud-download'

import {
  state_options
  delivery_state_options
} from '/models/email'

import { withEmails } from './queries'

# Sending State is ours; Receiver State, Opens and Clicks come from SES via the
# mailmonkey lambda, which writes them straight to mongo. They stay blank outside
# production.
export default \
withEmails \
class Emails extends React.Component

  render: ->
    <div className="Emails">
      {@filters()}
      {@list()}
      {@pager()}
    </div>

  filters: ->
    <Filters>
      <Filters.Search/>
      <Filters.State label='Sending State' options={state_options}/>
      <Filters.State label='Receiver State' name='delivery_state' options={delivery_state_options}/>
      <span className="pull-right">
        <Pager meta={@props.emailsPagination} buffer={2}/>
      </span>
    </Filters>

  list: ->
    return <Spinner/> if @props.emailsLoading
    <List>
      {@header()}
      {for email in @props.emails
        <List.Row key={email._key}>
          <List.Cell className="to" title={email.to}>{email.to}</List.Cell>
          <List.Cell className="subject" title={email.subject}>
            {email.subject}
            <br/>
            <small>{email.type.replace /_/g, ' '}</small>
          </List.Cell>
          <List.Cell className="created-at">
            <Datetime date={email.created_at}/>
          </List.Cell>
          <List.Cell className="count">{email.opens or 0}</List.Cell>
          <List.Cell className="count">{email.clicks or 0}</List.Cell>
          <List.Cell className="download">
            <a className="btn btn-default #{'disabled' unless email.s3_url}" href={email.s3_url}>
              <FaCloudDownload/>
            </a>
          </List.Cell>
          <List.Cell className="state">
            <StateLabel model={email}/>
          </List.Cell>
          <List.Cell className="state">
            <StateLabel model={email} state={email.delivery_state} title={email.delivery_message}/>
          </List.Cell>
        </List.Row>
      }
    </List>

  header: ->
    <List.HeaderRow>
      <List.Header className="to">To</List.Header>
      <List.Header className="subject">Subject</List.Header>
      <List.Header className="created-at">Sent</List.Header>
      <List.Header className="count">Opens</List.Header>
      <List.Header className="count">Clicks</List.Header>
      <List.Header className="download">Download</List.Header>
      <List.Header className="state">Sending State</List.Header>
      <List.Header className="state">Receiver State</List.Header>
    </List.HeaderRow>

  pager: ->
    <div className="text-center">
      <Pager meta={@props.emailsPagination} buffer={4}/>
    </div>
